'use client';

import { FloatingOverlay } from '@floating-ui/react';
import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { DatePickerRootContext } from './context/date-picker-root.context';
import { datePickerBackdropRecipe } from './styles/date-picker-backdrop.styles';
import type { DatePickerBackdropPropsInterface } from './types/date-picker-backdrop.types';

/**
 * @since 10.0.0
 */
export const DatePickerBackdrop = forwardRef<HTMLDivElement, DatePickerBackdropPropsInterface>(
  (props: DatePickerBackdropPropsInterface, forwardedRef) => {
    const { modal } = useContext(DatePickerRootContext);
    const { children, className, css: cssProp, lockScroll = true, ...rest } = props;

    const styles = css(datePickerBackdropRecipe.raw({ modal }), cssProp);

    const Component = modal ? FloatingOverlay : 'div';

    return (
      <Component
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="DatePicker.Backdrop"
        className={cx('c11n', 'c11n_date-picker__backdrop', styles, className)}
        {...(modal ? { lockScroll } : {})}
        {...rest}
      >
        {children}
      </Component>
    );
  },
);

DatePickerBackdrop.displayName = 'DatePicker.Backdrop';
